module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_harei-ccf4a15b591bcfe28e76b100b499b22c.png";